import React, { useRef } from 'react';
import img from '../assets/historias-de-exito/exitoImage01.png';
import img1 from '../assets/historias-de-exito/exitoImage02.png';
import img1mobile from '../assets/historias-de-exito/exitoImage02-mobile.png';

const HistoriasExito = () => {
  // Creamos un contenedor de refs
  const sectionRefs = useRef([]);
  const historias = [
    {
      id: 1,
      cliente: 'Etiquetas para marca Chobani',
      testimonio: 'En el proceso de producción de etiquetas para la marca de yogurt Chobani, se implementó un sistema de impresión masiva que garantizó la eficiencia y la calidad del producto final. Se utilizaron materiales de alta calidad para asegurar que cada etiqueta no solo fuera atractiva, sino también resistente y duradera. Después de un riguroso control de calidad, las etiquetas fueron empaquetadas y entregadas a tiempo, asegurando que cada envase de yogurt Chobani llegara a los estantes con una presentación impecable.',
      fecha: '2019'
    },
    {
      id: 2,
      cliente: 'Vasos Inmold para Festival de Música México',
      testimonio: 'En el marco del Festival de Música 2022, se llevó a cabo un innovador proyecto de creación de Vasos Inmold. Se produjeron un total de 10,000 vasos, diseñados específicamente para ser ecológicos y atractivos. El equipo trabajó de manera coordinada, superando desafíos logísticos y garantizando que cada vaso se entregara a tiempo. Gracias a una planificación meticulosa y a la colaboración entre todos los involucrados, el proyecto se completó con éxito, contribuyendo a la sostenibilidad del evento y mejorando la experiencia de los asistentes.',
      fecha: '2022'
    }
  ];

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">

          {/* Frase de historias de exito */}
          <div className='container-fluid pdg-section-ch img-hist-exito'>
            <div className="row align-items-center mb-md-5 mb-0">
              <div className="col-12 text-start p-md-0">
                <h1 className="display-4 lightblack mb-3 tit-principal" style={{width:'70%', marginBottom: '5.5%'}}>
                    <span style={{ color: 'var(--color-principal)' }}>Somos más que etiquetas.
                     </span> Este es nuestro legado.
                </h1>
                {/*<div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-8 col-12 p-md-0 py-5'>
                      <img src={img} alt='Materia prima' />
                    </div>
                    <div className='col-md-4 col-12 p-md-auto '>
                      <img src={img1} alt='Fabricación de etiquetas' style={{width: '101%'}}/>
                    </div>

                  </div>
                </div>*/}
                <div className='container-fluid p-0 d-md-block d-none'>
                  <div className='cont-hist'>
                    <img className='imgexito1' src={img} alt='Materia prima' />
                    <img className='imgexito2' src={img1} alt='Fabricación de etiquetas' />
                  </div>
                </div>
                <div className='container-fluid p-0 d-md-none d-block'>
                  <div className='cont-hist'>
                    <img src={img} alt='Materia prima' />
                    <img src={img1mobile} alt='Fabricación de etiquetas' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contenido de Historias de Exito */}
          <div className='container-fluid pdg-section-scroll hist-exito' style={{ background: 'var(--color-text-negro-light)', paddingTop: '8%' }}>
            <div className="row align-items-start mb-4">
                <div className="col-12 col-md-12 p-0 pe-md-4 pb-5" style={{marginBottom:'9.5%'}}>
                  <h2 style={{ color: '#fff', }} className="mb-4 tit-principal " >
                    <span style={{ color: 'var(--color-principal)' }}>Cada etiqueta impresa en Mega Label es parte de la historia de nuestros clientes: </span>
                    marcas que perduran e inspiran confianza.
                  </h2>
                    <p style={{ color: '#fff', fontWeight:'400' }}>
                      Nuestra herencia se resume en más que etiquetas.
                    </p>

                  <p style={{ color: '#fff', fontWeight:'900' }}>
                    Son símbolo de experiencias memorables que cruzan fronteras y generaciones.
                  </p>

                  <p style={{ color: '#fff', fontWeight:'500' }}>
                    Aquí te mostramos cómo nuestras etiquetas se convierten en piezas fundamentales de éxito y crecimiento para las marcas que confían en nosotros.
                  </p>
                </div>
                {/* Contenido de cada historia */}
                <div className="col-12 col-md-12 p-0">
                  {historias.map((historia, idx) => (
                    <div
                      key={historia.id}
                      ref={sectionRefs[idx]}
                      id={historia.id}
                      className="pb-4"
                      style={{
                        borderBottom: '1px solid #333',
                        scrollMarginTop: '120px',
                        background:'var(--color-text-gris-light)',
                        padding: '3% 2.5%',
                        borderRadius: '16px ',
                        marginBottom: '5%'
                      }}
                    >  
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-6 col-12 ps-0'>
                            {/*<p style={{ color: 'var(--color-principal)', margin:'0%', fontSize: '1.58rem' }}>{historia.fecha}</p>*/}
                            <h2  className="mb-4 tit-principal" >{historia.cliente}</h2>
                          </div>
                          <div className='col-md-6 col-12 pe-0' style={{paddingLeft:'3%'}}> 
                            <p style={{ color: '#fff', padding:'4.5% 1%', fontWeight:'300'}}>{historia.testimonio}</p>
                          </div> 
                        </div>
                      </div> 
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/*Frase segunda de Historias de Exito */}
            <div className='container-fluid pdg-section-ch hist-exito'>
              <div className="row align-items-center mb-5">
                <div className="col-lg-12">
                  <h1 className="display-4 mb-4 tit-principal" style={{width:'95%'}}>
                    <span style={{ color: 'var(--color-principal)'}}>Cada etiqueta es parte de un legado.</span> <br></br>
                    <span style={{color: 'var( --color-text-negro-light)'}}> Deja que tu etiqueta cuente la historia.</span>
                  </h1>    
                  <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom p-3 mt-3 mb-5">
                    Empieza aquí
                  </a> 
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
  );
};

export default HistoriasExito; 